import { GetStaticProps } from "next";

import { getPictures } from "~/api/pictures/getPictures";
import { getTags } from "~/api/tags/getTags";
import CultureImages from "~/components/culture/images";
import CultureIntroduction from "~/components/culture/introduction";
import SEO from "~/components/SEO";
import { PictureType } from "~/types/picture/picture.types";
import { FilterTagsEnum, TagType } from "~/types/tag/tag.types";

import styles from "./index.module.scss";

interface Props {
  tags: TagType[];
  pictures: PictureType[];
}

export const getStaticProps: GetStaticProps<Props, never> = async () => {
  const tags = await getTags(FilterTagsEnum.PICTURES);
  const pictures = await getPictures();
  return {
    props: { tags, pictures },
  };
};

const Culture = ({ tags, pictures }: Props) => {
  return (
    <>
      <SEO
        title="Silencio - Culture"
        description="Une décennie d’avant-garde à découvrir en images. "
        nofollow={false}
        noindex={false}
      />
      <div className={styles.containerForCulture}>
        <CultureIntroduction />
        <CultureImages tags={tags} pictures={pictures} />
      </div>
    </>
  );
};

export default Culture;
